import React from 'react';
import { Snackbar, Alert, Box } from '@mui/material';
import '../../entrevista/components/EntrevistaViewer.css';
import { useCapacidadFuncionalViewer } from '../hooks/useCapacidadFuncionalViewer';
import {
  CapacidadFuncionalHero,
  CapacidadFuncionalMetrics,
  PatientProfileSection,
  EquilibrioSection,
  MarchaYFuerzaSection,
  TUGSection,
  ViewerActions,
} from './viewer/CapacidadFuncionalViewerSections';

const CapacidadFuncionalViewer = ({ idTipo, paciente }) => {
  const {
    patientInfo,
    fields,
    isEditing,
    openGood,
    metrics,
    setOpenGood,
    setField,
    handleEdit,
    handleCancel,
    handleSave,
    handleDelete,
    handleExportPDF,
  } = useCapacidadFuncionalViewer({ idTipo, paciente });

  const onFieldChange = (fieldName) => (event) => setField(fieldName, event.target.value);
  const onCheckChange = (fieldName) => (event) => setField(fieldName, event.target.checked);

  return (
    <Box className="entrevista-viewer" sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Box className="entrevista-viewer__shell" sx={{ maxWidth: 1080, width: '100%' }}>
        <Box id="pdf-content" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <CapacidadFuncionalHero createdAt={patientInfo.createdAt} />
          <CapacidadFuncionalMetrics metrics={metrics} />
          <PatientProfileSection patientInfo={patientInfo} />
          <EquilibrioSection fields={fields} isEditing={isEditing} onFieldChange={onFieldChange} />
          <MarchaYFuerzaSection fields={fields} isEditing={isEditing} onFieldChange={onFieldChange} />
          <TUGSection
            fields={fields}
            isEditing={isEditing}
            onFieldChange={onFieldChange}
            onCheckChange={onCheckChange}
          />
        </Box>

        <ViewerActions
          isEditing={isEditing}
          onEdit={handleEdit}
          onSave={handleSave}
          onCancel={handleCancel}
          onExportPDF={handleExportPDF}
          onDelete={handleDelete}
        />

        <Snackbar open={openGood} autoHideDuration={2000} onClose={() => setOpenGood(false)}>
          <Alert severity="success" onClose={() => setOpenGood(false)}>
            ¡Informe actualizado!
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
};

export default CapacidadFuncionalViewer;
